import { LangList } from '~~/modules/lang/entities/Lang'

export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig()

  const v2ApiNuxtEndpointPlugin = async (
    endpointName: string,
    params: object,
  ): Promise<any> => {
    try {
      const endpointUrl = `${runtimeConfig.public.NUXT_API_CONTENT_ROOT_URL}/${endpointName}`
      let headers: HeadersInit = useRequestHeaders(['cookie']) as HeadersInit

      headers = {
        ...headers,
        language: LangList['es-ES'],
      }

      const { data } = await useFetch<any>(endpointUrl, { params, headers })

      return data.value
    } catch (errorApi) {
      console.error('errorApi', errorApi)
    }
  }

  const v2ApiNuxtEndpointPostPlugin = async (
    endpointName: string,
    params: object,
  ): Promise<any> => {
    try {
      const endpointUrl = `${runtimeConfig.public.NUXT_API_CONTENT_ROOT_URL}/${endpointName}`
      let headers: HeadersInit = useRequestHeaders(['cookie']) as HeadersInit

      headers = {
        ...headers,
        language: LangList['es-ES'],
      }
      const { data } = await useFetch<any>(endpointUrl, {
        body: params,
        headers,
        method: 'POST',
      })

      return data.value
    } catch (errorApi) {
      console.error('errorApi', errorApi)
    }
  }

  return {
    provide: {
      v2ApiNuxtEndpointPlugin,
      v2ApiNuxtEndpointPostPlugin,
    },
  }
})
